import { render, staticRenderFns } from "./TelefonskiPovici.vue?vue&type=template&id=a7453546&scoped=true"
import script from "./TelefonskiPovici.vue?vue&type=script&lang=js"
export * from "./TelefonskiPovici.vue?vue&type=script&lang=js"
import style0 from "./TelefonskiPovici.vue?vue&type=style&index=0&id=a7453546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7453546",
  null
  
)

export default component.exports